module.exports = __webpack_public_path__ + "static/media/google_play_badge.edf17dde.png";